export const getFirstName = (state) => state.user.firstName
export const getUserID = (state) => state.user.id
